import { useEffect } from 'react';
import useQuranReader from '../../hooks/useQuranReader';
import { useGoals } from '../../contexts/GoalsContext';
import { recordVerseForCommunity } from '../../utils/communityStats';

// Headless: it watches the reader and feeds the log, and renders nothing.
//
// A verse counts as soon as it is on screen. There was a three second delay
// here to guard against flipping through, but plenty of people read faster than
// that, and the counters exist for the reader's own benefit — padding them only
// cheats themselves.
const ReadingTracker = () => {
  const { currentSurah, currentVerse, loading, error } = useQuranReader();
  const { recordVerseRead } = useGoals();

  useEffect(() => {
    // Verse 0 is the Bismillah, and a verse that failed to load was never read
    if (loading || error || currentVerse < 1) return;
    recordVerseRead(currentSurah, currentVerse);
    recordVerseForCommunity();
  }, [currentSurah, currentVerse, loading, error, recordVerseRead]);

  return null;
};

export default ReadingTracker;
